import { useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import { useAppStore } from '@/stores/appStore'

export function useAuth() {
  const { session, isAuthLoading, setSession, setAuthLoading } = useAppStore()

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setAuthLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session)
        setAuthLoading(false)
      }
    )

    return () => subscription.unsubscribe()
  }, [setSession, setAuthLoading])

  const signInWithGitHub = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'github',
      options: {
        redirectTo: window.location.origin,
        scopes: 'repo read:user',
      },
    })
  }

  const signOut = async () => {
    await supabase.auth.signOut()
  }

  return { session, isAuthLoading, signInWithGitHub, signOut }
}
